module.exports = __webpack_public_path__ + "img/1547094500.17dbc38b.jpg";